/** Fecha de escena más reciente (YYYY-MM-DD) entre resultados NDVI; null si ninguno la trae. */
export function latestNdviSceneDate(results: { imageDate?: string | null }[] | undefined): string | null {
  const dates = (results ?? []).map(r => r.imageDate).filter((d): d is string => !!d);
  return dates.length ? dates.sort()[dates.length - 1] : null;
}

/** 'YYYY-MM-DD' → 'DD/MM/AAAA' (sin pasar por Date para evitar corrimiento de zona horaria). */
export function formatSceneDate(isoDate: string): string {
  const [y, m, d] = isoDate.split('-');
  return `${d}/${m}/${y}`;
}
